<template>
  <v-dialog :value="isActive" persistent max-width="800" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="font-weight-medium primary--text">
          {{ isEditMode ? "Actualizar" : "Crear" }} configuración de variables de campaña
        </v-card-title>

        <v-divider></v-divider>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 500px">
            <v-row>
              <!-- Nombre -->
              <v-col cols="12" class="mt-4 py-0">
                <ValidationProvider
                  name="nombre"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.name"
                    :error-messages="errors"
                    label="Nombre"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Descripción -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="descripción"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.description"
                    :error-messages="errors"
                    label="Descripción"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Cliente -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="nombre del cliente" rules="required" v-slot="{ errors }">
                  <v-select
                    v-model="payload.client_id"
                    :items="Clients"
                    :error-messages="errors"
                    :loading="isLoadingClients"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-database"
                    label="Nombre del cliente de PBXBerry"
                    filled
                    rounded
                    dense
                    class="rounded-small"
                  ></v-select>
                </ValidationProvider>
              </v-col>

              <!-- Campaña -->
              <v-col cols="12" class="pb-0">
                <!-- <ValidationProvider name="nombre del cliente" rules="required" v-slot="{ errors }"> -->
                  <v-select
                    v-model="payload.campaign_id"
                    prepend-inner-icon="mdi-bell"
                    required
                    filled
                    rounded
                    dense
                    class="rounded-small"
                    item-text="name"
                    item-value="id"
                    :items="campaignList"
                    label="Campaña"
                  ></v-select>
                <!-- </ValidationProvider> -->
              </v-col>

              <!-- Var1 -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="var1"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.var1"
                    :error-messages="errors"
                    label="Var1"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Var1 -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="var2"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.var2"
                    :error-messages="errors"
                    label="Var2"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Var1 -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="var3"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.var3"
                    :error-messages="errors"
                    label="Var3"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Var1 -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="var4"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.var4"
                    :error-messages="errors"
                    label="Var4"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Var1 -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="var5"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.var5"
                    :error-messages="errors"
                    label="Var5"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Var1 -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="var6"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.var6"
                    :error-messages="errors"
                    label="Var6"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Var1 -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="var7"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.var7"
                    :error-messages="errors"
                    label="Var7"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Var1 -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="var8"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.var8"
                    :error-messages="errors"
                    label="Var8"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Var1 -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="var9"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.var9"
                    :error-messages="errors"
                    label="Var9"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Var1 -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="var10"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.var10"
                    :error-messages="errors"
                    label="Var10"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";
import vuescroll from "vuescroll";

export default {
  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      default: {},
    },
  },

  components: {
    vuescroll,
  },

  data() {
    return {
      isLoadingClients: true,
      isLoading: false,
      // externalClientList: [],
      campaignList: [],
      payload: {
        name: "",
        description: "",
        client_id: null,
        campaign_id: null,
        var1: "",
        var2: "",
        var3: "",
        var4: "",
        var5: "",
        var6: "",
        var7: "",
        var8: "",
        var9: "",
        var10: "",
      },
    };
  },

  computed: {
    Clients() {
      return this.$store.getters["clients/GET_ALL_CLIENTS"];
    },
  },

  created() {
    // this.getQueues();
    // this.getExternalClients();
    this.GetClients();
    this.getCampaigns();
    this.payload = { ...this.dataToEdit };
  },

  methods: {
    resetform() {
      this.payload.client_id = "";
      this.payload.campaign_id = null;
      this.payload.simultaneity = null;
      this.payload.url_response = "";
      this.payload.assignment_agent = null;
      this.payload.audio = "";
      this.payload.queue_id = null;
      this.payload.external_id = null;
    },

    async GetClients() {
      try {
        const response = await this.$store.dispatch("clients/SHOW_CLIENTS");
        this.data = response.data;
        this.isLoadingClients = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getCampaigns() {
      try {
        const { data } = await PbxHttpClient.get(
          `/campaign/campaign?itemPerPage=100`
        );
        this.campaignList = data.data;
      } catch (err) {
        console.log("error getting campaign", err);
      }
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    // async getQueues() {
    //   try {
    //     const { data } = await PbxHttpClient.get(`/clients/queues`);
    //     this.queueList = data.data;
    //     const salida = data.data.find((el) => el.name === "salida");
    //     if (salida) this.payload = { ...this.payload, queue: salida.number };
    //   } catch (err) {
    //     this.$snotify.error("Hubo un error consultando las colas.", "¡Error!");
    //   }
    //   this.isLoadingQueues = false;
    // },

    // async getExternalClients() {
    //   try {
    //     const { data } = await PbxHttpClient.get(`/clients/external/select`);
    //     this.externalClientList = data;
    //   } catch (err) {
    //     this.$snotify.error(
    //       "Hubo un error consultando los clientes externos.",
    //       "¡Error!"
    //     );
    //   }
    //   this.isLoadingQueues = false;
    // },

    async submitForm() {
      this.isLoading = true;

      const accessToken = localStorage.getItem("token");

      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(
              `/campaign/campaign_variable/${id}`,
              payload
            )
          : await PbxHttpClient.post(
              "/campaign/campaign_variable",
              payload
            );
        this.closeDialog(data.external);

        this.$snotify.success("Configuración creada con éxito.", "¡Hecho!");
      } catch (err) {
        this.isLoading = false;
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }
    },
  },
};
</script>
